import React, { useState } from "react";
import { connect } from "react-redux";
import PrecertificacionActions from "../../../stores/precertificacion/Actions";
import AuthActions from "../../../stores/auth/Actions";
import { useMountEffect, useUpdateEffect } from "../../../hooks/LifeCycle";
import useEmpresa from "../../../hooks/useEmpresa";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import CheckRender from "../../../components/Common/CheckRender";
import TittleLine from "../../../components/Common/TittleLine";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import DetallePrecertificacion from "../components/DetallePrecertificacion";
import BusquedaPrecertificacionForm from "../components/BusquedaPrecertificacionForm";
import {
  PRECERTIFICACION_WARNING,
  ESTADO_PRECERTIFICACION,
  getFooterPosition,
  getFooterWidth,
} from "../utils/PrecertificacionConstants";
import { isObjectEmpty } from "../../../utils/ObjectUtil";
import CustomAlert from "../../../components/Common/CustomAlert";
import { mostrarErrorGenerico } from "../../../utils/AlertUtils";
import { isEmptyValue } from "../../../utils/StringUtil";

const CancelarPrecertificacionScreen = (props) => {
  const empresa = useEmpresa();

  const [formData, setFormData] = useState({
    numeroPrecertificacion: "",
  });

  const [showDetail, setShowDetail] = useState(false);

  const [dataPrecertificacion, setDataPrecertificacion] = useState(null);

  const [processing, setProcessing] = useState(false);

  const [showAlert, setShowAlert] = useState(false);

  const [alertConfig, setAlertConfig] = useState({});

  useMountEffect(() => {
    props.clearSesion();
  });

  /**
   * Consultar precertificación Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getPrecertificacionData) && processing) {
      setProcessing(false);

      setDataPrecertificacion(props?.getPrecertificacionData?.precertificacion);

      setShowDetail(true);
    }
  }, [props.getPrecertificacionData]);

  /**
   * Consultar precertificación Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getPrecertificacionError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.getPrecertificacionError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.getPrecertificacionError]);

  /**
   * Cancelar precertificación Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.cancelarPrecertificacionData) && processing) {
      setProcessing(false);

      setDataPrecertificacion({
        ...dataPrecertificacion,
        nombreEstado: ESTADO_PRECERTIFICACION.CANCELADA,
      });

      setAlertConfig({
        type: "success",
        title: `Precertificación ${dataPrecertificacion?.numeroPrecertificacion} cancelada con éxito!`,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
    }
  }, [props.cancelarPrecertificacionData]);

  /**
   * Cancelar precertificación Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.cancelarPrecertificacionError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.cancelarPrecertificacionError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.cancelarPrecertificacionError]);

  const onStateChange =
    (key, format = null) =>
    (value) => {
      setFormData((prevState) => {
        return {
          ...prevState,
          [key]: format ? format(value) : value,
        };
      });
    };

  const busquedaPrecertificacion = () => {
    const { numeroPrecertificacion } = formData;

    if (isEmptyValue(numeroPrecertificacion)) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: "Favor ingresar el número de precertificación.",
        onConfirm: () => {
          setShowAlert(false);
        },
      });

      setShowAlert(true);
      return;
    }

    setShowDetail(false);

    const { numeroSesionReutilizable } = props?.authUserData;

    setProcessing(true);

    props.getPrecertificacion({
      numeroSesion: numeroSesionReutilizable,
      numeroPrecertificacion: formData.numeroPrecertificacion,
      compania: empresa?.CODIGO,
    });
  };

  const cancelar = () => {
    const { numeroSesionReutilizable } = props?.authUserData;

    setProcessing(true);

    props.cancelarPrecertificacion({
      numeroSesion: numeroSesionReutilizable,
      numeroPrecertificacion: dataPrecertificacion?.numeroPrecertificacion,
      compania: empresa?.CODIGO,
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      busquedaPrecertificacion();
    }
  };

  return (
    <CustomLayout
      showMenuNav={true}
      footerPosition={getFooterPosition(showDetail)}
      footerWidth={getFooterWidth(showDetail)}
    >
      <Section>
        <TittleLine title={`Cancelar Precertificación`} weight={"bold"} />
      </Section>

      <Section>
        <BusquedaPrecertificacionForm
          {...formData}
          onStateChange={onStateChange}
          onSearch={busquedaPrecertificacion}
          isLoading={props.getPrecertificacionLoading}
          handleKeyPress={handleKeyPress}
        />
      </Section>

      <CheckRender allowed={showDetail}>
        <Section>
          <DetallePrecertificacion
            dataPrecertificacion={dataPrecertificacion}
            actionButtonLoading={props.cancelarPrecertificacionLoading}
            onSubmitAction={cancelar}
            actionButton={"Cancelar"}
            warningText={PRECERTIFICACION_WARNING.CANCELAR}
          />
        </Section>
      </CheckRender>

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  getPrecertificacionData: state.precertificacion.getPrecertificacionData,
  getPrecertificacionLoading: state.precertificacion.getPrecertificacionLoading,
  getPrecertificacionError: state.precertificacion.getPrecertificacionError,

  cancelarPrecertificacionData:
    state.precertificacion.cancelarPrecertificacionData,
  cancelarPrecertificacionLoading:
    state.precertificacion.cancelarPrecertificacionLoading,
  cancelarPrecertificacionError:
    state.precertificacion.cancelarPrecertificacionError,
});

const mapDispatchToProps = {
  clearSesion: AuthActions.clearSesion,
  getPrecertificacion: PrecertificacionActions.getPrecertificacion,
  cancelarPrecertificacion: PrecertificacionActions.cancelarPrecertificacion,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CancelarPrecertificacionScreen);
